// extracted by mini-css-extract-plugin
module.exports = {"root":"PaginationRoutes_root__R2YxP","pagination":"PaginationRoutes_pagination__dKxWy","route":"PaginationRoutes_route__zcc1Y","nonClick":"PaginationRoutes_nonClick__642g5"};